"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var React = require('react');
var patterns_1 = require('../components/patterns');
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        _super.call(this);
        this.state = {
            allPatterns: [
                "000",
                "001",
                "010",
                "011",
                "100",
                "101",
                "110",
                "111"
            ].reverse()
        };
    }
    default_1.prototype.render = function () {
        var _a = this.props, activePatterns = _a.activePatterns, changePattern = _a.changePattern;
        var patterns = this.state.allPatterns.map(function (pattern) { return ({
            pattern: pattern
                .split('')
                .map(function (s) { return Boolean(Number(s)); }),
            signature: pattern,
            state: activePatterns.indexOf(pattern) >= 0,
            changePattern: changePattern
        }); });
        return React.createElement(patterns_1.default, {patterns: patterns});
    };
    return default_1;
}(React.PureComponent));
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = default_1;



/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/patterns.tsx
 ** module id = 7
 ** module chunks = 0
 **/